import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";

export default class extends Controller {
  static get targets() {
    return ["step", "collapsible"];
  }

  static get values() {
    return { store: Boolean };
  }

  connect() {
    if (this.saveToStore) this._registerWithStore();

    M.Collapsible.init(this.collapsibleTarget, {
      accordion: false,
      onOpenEnd: () => this._syncWithStore(),
      onCloseEnd: () => this._syncWithStore()
    });
  }

  next(event) {
    event.preventDefault();

    const currentLi = event.target.closest("li");
    const currentIndex = this.stepTargets.indexOf(currentLi);
    const nextIndex = currentIndex + 1;

    if (nextIndex < this.stepTargets.length) {
      const nextLi = this.stepTargets[nextIndex];

      nextLi.classList.remove("disabled");

      this.materializeCollapsible.close(currentIndex);
      this.materializeCollapsible.open(nextIndex);

      if (this.saveToStore) this._syncWithStore();

      nextLi.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  openAllNextSteps(event) {
    const currentLi = event.target.closest("li");
    const currentIndex = this.stepTargets.indexOf(currentLi);

    this.stepTargets.forEach((li, index) => {
      if (index > currentIndex && !li.classList.contains("disabled")) {
        this.materializeCollapsible.open(index);
      }
    });

    if (this.saveToStore) this._syncWithStore();
  }

  // Store methods

  _registerWithStore() {
    this.dispatch("register", {
      detail: { id: this.element.id, values: [] },
      prefix: false,
    });
  }

  _syncWithStore() {
    this.dispatch("sync", {
      detail: { id: this.element.id, values: this.stateArr },
      prefix: false,
    });
  }

  updateFromStore({ detail: { id, values } }) {
    if (id !== this.element.id) return;

    const savedState = values;
    if (!savedState) return;


    savedState.forEach((state, index) => {
      const li = this.stepTargets[index];

      if (state.isDisabled === false) {
        li.classList.remove("disabled");
      } else {
        li.classList.add("disabled");
      }

      if (state.isOpen) {
        li.classList.add("active");
      } else {
        li.classList.remove("active");
      }
    });

  }

  get materializeCollapsible() {
    return M.Collapsible.getInstance(this.collapsibleTarget);
  }

  get stateArr() {
    return Array.from(this.stepTargets).map(li => {
      return {
        isOpen: li.classList.contains("active"),
        isDisabled: li.classList.contains("disabled")
      };
    });
  }

  get saveToStore() {
    return this.hasStoreValue && this.storeValue;
  }
}
